module.exports = {
    CLIMATE_API_KEY: '58d6db8739720ea3cecddb726f8f0293'
}